import type React from "react";
import type { MenuRulePermissionCanFn } from "@Front/Utils/filterMenuItemsByCan";
import type { IItem } from "./MenuItem";
import { useMatrixFilteredMenuItems } from "./useMatrixFilteredMenuItems";
import { useMenuSubmenuState } from "./useMenuSubmenuState";

type OpenSide = "left" | "right" | "center";

type MenuControllerProps = {
	items: IItem[];
	openingSide: OpenSide;
	openOnHover: boolean | undefined;
	/** Si défini, remplace le `can` du store pour le filtrage matrice (menu Espace office). */
	matrixCan?: MenuRulePermissionCanFn;
};

export function useMenuController(props: MenuControllerProps): {
	hide: boolean;
	openingSide: OpenSide;
	openOnHover: boolean | undefined;
	toggle: () => void;
	handleMouseEnter: () => void;
	handleMouseLeave: () => void;
	iconRef: React.RefObject<HTMLDivElement | null>;
	subMenuRef: React.RefObject<HTMLDivElement | null>;
	shouldShowSubMenu: boolean;
	effectiveItems: IItem[];
	isSuperAdmin: boolean;
	close: () => void;
} {
	const { items, openingSide, openOnHover, matrixCan } = props;
	const { effectiveItems, isSuperAdmin, loadingPermissions } = useMatrixFilteredMenuItems(items, matrixCan);
	const submenu = useMenuSubmenuState({
		effectiveItems,
		openingSide,
		openOnHover,
		isSuperAdmin,
		loadingPermissions,
	});
	const hide = !loadingPermissions && !isSuperAdmin && effectiveItems.length === 0;

	return {
		hide,
		openingSide,
		openOnHover,
		effectiveItems,
		isSuperAdmin,
		...submenu,
	};
}
